import api from 'services/api';
import { ParamsProps } from '../types';

export const getIntegrationData = async (params?: ParamsProps) =>
  api.get('/wms/integrations', { params });
